// extracted by mini-css-extract-plugin
module.exports = {"lottiePlayerComponent":"style_lottiePlayerComponent__2UN_z"};